import type { TUser } from "./types";
import { HTTP } from "@/api";
import { type AxiosResponse } from "axios";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "/auth/users";
const ME_SLUG = "/auth/users/me";

export default createService(SLUG, {
  async getAll(): Promise<AxiosResponse<TUser[]>> {
    return await HTTP.get<TUser[]>(`${SLUG}/`);
  },

  async get(id: number): Promise<AxiosResponse<TUser>> {
    return await HTTP.get<TUser>(`${SLUG}/${id}/`);
  },

  async update(id: string, user: Partial<TUser>): Promise<AxiosResponse<TUser>> {
    return await HTTP.patch<TUser>(`${SLUG}/${id}/`, user);
  },

  async resetPassword(email: string): Promise<AxiosResponse<void>> {
    return await HTTP.post<void>(`${SLUG}/reset_password/`, { email: email });
  },

  async resetPasswordConfirm(
    newPassword: string,
    uid: string,
    token: string
  ): Promise<AxiosResponse<void>> {
    return await HTTP.post<void>(`${SLUG}/reset_password_confirm/`, {
      new_password: newPassword,
      uid: uid,
      token: token,
    });
  },

  async setPassword(currentPassword: string, newPassword: string): Promise<AxiosResponse<void>> {
    return await HTTP.post<void>(`${SLUG}/set_password/`, {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },

  me: {
    async get(): Promise<AxiosResponse<TUser>> {
      return await HTTP.get<TUser>(`${ME_SLUG}/`);
    },

    async update(user: Partial<TUser>): Promise<AxiosResponse<TUser>> {
      return await HTTP.patch<TUser>(`${ME_SLUG}/`, user);
    },

    async delete(): Promise<AxiosResponse<void>> {
      return await HTTP.delete(ME_SLUG);
    },
  },
});
